import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

import { Division } from './types'

export const fetchDistributorDivisionList = async (params?: { clientId?: string, abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/division/distributors/${params?.clientId}`)
    .signal(params?.abortCtrl)
    .get()
    .json<{ userDivisions: Division[] }>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}

export const fetchAllDivision = async (params?: { abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/division/get/all`)
    .signal(params?.abortCtrl)
    .get()
    .json<{ divisions: Division[] }>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}
